import { useContext } from "react";
import {
  BodyAsistencia,
  BtnAceptar,
  ContainerAsistencia,
  HeaderAsistencia,
} from "./localStyle";
import { PortalContext } from "_+_Portal/context/Provider";
import { isMobile } from "react-device-detect";
import HeaderModal from "../headerModal/headerModal";

const AsistenciaModal = ({ actualizarPagina, dissmiss }) => {
  const { textosState } = useContext(PortalContext);

  let txtAsistencia = textosState.textos.data.msjAsistenciaDocOk;
  return (
    <ContainerAsistencia>
      <HeaderModal titulo={txtAsistencia.nombre} dissmiss={dissmiss} />
      <BodyAsistencia>
        <div className="ptur-turnoConfirmado-tilde">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={isMobile ? "96" : "146"}
            height={isMobile ? "96" : "146"}
            viewBox="0 0 100 100"
          >
            <circle
              class="ptur-circle-turnoConfirmado"
              cx="50"
              cy="50"
              r="45"
            ></circle>
            <path
              class="ptur-check-turnoConfirmado"
              d="M25 50 L40 65 L75 30"
            ></path>
          </svg>
        </div>
        <p className="rb18l">{txtAsistencia.descripcion}</p>
        <BtnAceptar
          className={"bgc-latex30 c-white rb18l"}
          onClick={actualizarPagina}
        >
          Aceptar
        </BtnAceptar>
      </BodyAsistencia>
    </ContainerAsistencia>
  );
};

export default AsistenciaModal;
